import baseSidebarTheme from "../baseSidebarTheme";

const prop1 = {
  ...baseSidebarTheme,
  // no overrides yet → identical to current look
};

export default prop1;
